var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #2b78e4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,5.1c0-.2,0-.3-.2-.5L9.5.6h-.2c0-.1-5.9-.1-5.9-.1l-.5.2c-.6.3-1.1.8-1.2,1.5,0,3.9,0,7.8,0,11.7.1.8.7,1.4,1.5,1.6,2.9,0,5.8,0,8.7,0,.9-.1,1.6-.8,1.7-1.7,0-2.9,0-5.8,0-8.8ZM12.9,13.8s-.1.3-.2.4c-.2.3-.4.5-.7.5-2.9,0-5.7,0-8.6,0-.5-.1-.8-.5-.9-1V2.3c0-.5.6-1,1.1-1h5.2v3.1c0,.2.1.5.3.6,0,0,.4.3.5.3h3.2v8.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.9,12.6c.1-.3.7-1,1-1.3.1-.2.5-.7.6-.8.1,0,.2,0,.3,0,.2,0,.7.8.9,1,0,0,0,0,0,0l1.6-2.4c.2-.2.4-.2.6,0l2.5,3.4c.2.3,0,.7-.3.7h-7c-.3-.1-.4-.3-.3-.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.6,
    cy: 8.3,
    r: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.d4a9cdfc52beccb547d3baaf44693a01.svg";
export { ForwardRef as ReactComponent };